import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { usePurchaseOrderMainCommentDelete } from '@/features/purchase-order/hooks/use-purchase-order-main-comment-delete';

type PurchaseOrderMainCommentDeleteProps = {
  commentId: number;
  open: boolean;
  setOpen: (value: boolean) => void;
  purchaseOrderId: string;
};

export function PurchaseOrderMainCommentDelete({
  commentId,
  open,
  setOpen,
  purchaseOrderId,
}: PurchaseOrderMainCommentDeleteProps) {
  const { t } = useTranslation('purchaseOrder');
  const { onSubmit, isSubmitting } = usePurchaseOrderMainCommentDelete({
    commentId,
    purchaseOrderId,
    setOpen,
  });

  const onOpenChange = (nextOpen: boolean) => {
    if (isSubmitting) {
      return;
    }
    setOpen(nextOpen);
  };

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('Delete comment')}</DialogTitle>
          <DialogDescription>
            {t('Delete comment description')}
          </DialogDescription>
        </DialogHeader>
        <div className='flex w-full justify-end gap-2'>
          <DialogClose asChild>
            <Button disabled={isSubmitting} type='button' variant='outline'>
              {t('cancel', { ns: 'common' })}
            </Button>
          </DialogClose>
          <Button
            disabled={isSubmitting}
            onClick={handleSubmit}
            type='button'
            variant='destructive'
          >
            {t('delete', { ns: 'common' })}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
